import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  OutlinedInput,
  styled,
} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CustomOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--main-theme-color) !important",
    borderWidth: "1px !important",
  },
}));

const PatientStatusSelect = ({ data, metadata, handleMetadataChange }) => {
  const [selectValue, setSelectValue] = useState("");

  useEffect(() => {
    if (metadata?.[data?.value]) {
      setSelectValue(metadata?.[data?.value]);
    }
  }, [metadata, data]);

  return (
    <FormControl fullWidth className="add-edit-select">
      <InputLabel id={`${data?.value}-label`}>{data?.label}</InputLabel>
      <Select
        labelId={`${data?.value}-label`}
        value={selectValue}
        label={data?.label}
        onChange={handleMetadataChange}
        MenuProps={MenuProps}
        name={data?.value}
        input={<CustomOutlinedInput label={data?.label} />}
      >
        {data?.menuItems?.map((item) => (
          <MenuItem value={item?.value} key={item?.value}>
            {item?.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PatientStatusSelect;
